// var images = document.querySelectorAll(".partnersgrid__cell img");
// function adjustImageWidth(image) {
//     var widthBase = 115;
//     var scaleFactor = 0.525;
//     var imageRatio = image.naturalWidth / image.naturalHeight;

//     image.style.width = Math.pow(imageRatio, scaleFactor) * widthBase + 'px';
// }

// images.forEach(adjustImageWidth);


import {ratiologos} from 'ratiologos';

ratiologos({
    element: '.partnersgrid__cell img'
})